import { getWindowObject } from '@eventbrite/legacy-infra.feature-detection';

export const getQueryParam = (param: string, defaultValue?: string) => {
    const query = new URLSearchParams(getWindowObject('location')?.search);
    const value = query.get(param);
    return value ?? defaultValue;
};
